import { api, qs } from '../client'
import type { Page, Post } from '../types'

export const bookmarksApi = {
  list: (cursor?: string, limit = 20) => api.get<Page<Post>>(`/bookmarks${qs({ cursor, limit })}`),
}
